export default __webpack_public_path__ + "media/images/paylogos/gray/maestro@2x-970aa4e366378a2f3809a2f3b63a83cd.png";